/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import reference from './dashboardHyperlinkHandlerReference';

export default {
    events: {
        click: function (ev, link, dashlet) {
            reference.events.click.apply(this, arguments);
        }
    }
};